export interface ProductoArchivo{
    iddecinvproductoarchivo: number,
    iddecinvproyectoprodtermin: number,
    numero: number,
    refarchivo: string,
    ultimoCambio: Date,
}

export function getVoidProductoArchivo():ProductoArchivo{
    return{
        iddecinvproductoarchivo: 0,
        iddecinvproyectoprodtermin: 0,
        numero: 0,
        refarchivo: "",
        ultimoCambio: new Date()
    }
}

export function setProductoArchivo(row: any):ProductoArchivo{
    return{
        iddecinvproductoarchivo: row.iddecinvproductoarchivo??0,
        iddecinvproyectoprodtermin: row.iddecinvproyectoprodtermin??0,
        numero: row.numero??0,
        refarchivo: row.refarchivo??"",
        ultimoCambio: row.ultimoCambio??new Date()
    }
}

export function setListProductoArchivo(data: Array<any>): Array<ProductoArchivo>{
    //console.log(data)
    let list: Array<ProductoArchivo> = [];
    data.forEach((item) => {
        const i: ProductoArchivo = setProductoArchivo(item)
        list.push(i);
    });
    return list;
}